
export function CVFolderHeader({ project_id, folder_name }: { project_id: string; folder_name: string; }) {
    return (
        <div className="flex flex-col gap-2">
            <h1 className="text-2xl font-bold">{project_id} - {folder_name.charAt(0).toUpperCase() + folder_name.slice(1)} Folder</h1>
        </div>
    );
}
